import React, { useState } from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXTwitter, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons';
import SocialMediaModal from '../SocialMediaModal/SocialMediaModal';

function Footer() {
    const [hoveredLink, setHoveredLink] = useState(null);
    const [socialModalOpen, setSocialModalOpen] = useState(false);

    const handleMouseEnter = (linkName) => {
        setHoveredLink(linkName);
    };

    const handleMouseLeave = () => {
        setHoveredLink(null);
    };

    const linkStyle = (linkName) => ({
        textDecoration: 'none',
        color: hoveredLink === linkName ? '#fdd835' : 'white',
    });

    const handleSocialMediaClick = (e, hasLink) => {
        if (!hasLink) {
            e.preventDefault();
            setSocialModalOpen(true);
        }
    };

    const closeSocialModal = () => {
        setSocialModalOpen(false);
    };
    return (
        <div className="footer-container1">
            <div className="footer-company-logo"><h2>Astra Clean</h2></div>
            <div className="footer-company-description">
                <div className="footer-company-info">
                    <div className="footer-company-info-title">Company</div>
                    <ul>
                        <li>
                            <Link
                                to="/about"
                                style={linkStyle('about')}
                                onMouseEnter={() => handleMouseEnter('about')}
                                onMouseLeave={handleMouseLeave}
                            >
                                About us
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/term&condition"
                                style={linkStyle('terms')}
                                onMouseEnter={() => handleMouseEnter('terms')}
                                onMouseLeave={handleMouseLeave}
                            >
                                Terms & conditions
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/privacypolicy"
                                style={linkStyle('privacy')}
                                onMouseEnter={() => handleMouseEnter('privacy')}
                                onMouseLeave={handleMouseLeave}
                            >
                                Privacy Policy
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/refundPolicy"
                                style={linkStyle('refund')}
                                onMouseEnter={() => handleMouseEnter('refund')}
                                onMouseLeave={handleMouseLeave}
                            >
                                Refund Policy
                            </Link>
                        </li>
                    </ul>
                </div>
                <div className="footer-company-info">
                    <div className="footer-company-info-title">For customers</div>
                    <ul>
                        <li>
                            <Link
                                to="/reviews"
                                style={linkStyle('reviews')}
                                onMouseEnter={() => handleMouseEnter('reviews')}
                                onMouseLeave={handleMouseLeave}
                            >
                                Reviews
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/contact"
                                style={linkStyle('contact')}
                                onMouseEnter={() => handleMouseEnter('contact')}
                                onMouseLeave={handleMouseLeave}
                            >
                                Contact us
                            </Link>
                        </li>

                    </ul>
                </div>
                <div className="footer-company-info">
                    <div className="footer-company-info-title">Support</div>
                    <ul>
                        <li>
                            <Link
                                to="/help-support"
                                style={linkStyle('help-support')}
                                onMouseEnter={() => handleMouseEnter('help-support')}
                                onMouseLeave={handleMouseLeave}
                            >
                                Help Support
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/safety-center"
                                style={linkStyle('safety-center')}
                                onMouseEnter={() => handleMouseEnter('safety-center')}
                                onMouseLeave={handleMouseLeave}
                            >
                                Safety Center
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/community-guidelines"
                                style={linkStyle('community-guidelines')}
                                onMouseEnter={() => handleMouseEnter('community-guidelines')}
                                onMouseLeave={handleMouseLeave}
                            >
                                Community Guidelines
                            </Link>
                        </li>
                    </ul>
                </div>
                <div className="footer-company-info">
                    <div className="footer-company-info-title">Install App</div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <a href="https://play.google.com/store/apps/details?id=com.cleanto.astraclean" target="_blank" rel="noopener noreferrer">
                            <img
                                alt="Get it on Google Play"
                                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                                style={{ height: '60px', width: '120px' }}
                            />
                        </a>
                    </div>
                    <div className="footer-company-info-title">Our Social Media Handles</div>
                    <div className="social-icons-container">
                       
                        <button
                            className="social-button"
                            aria-label="YouTube"
                            onClick={(e) => handleSocialMediaClick(e, false)}
                            style={{ border: 'none', cursor: 'pointer' }}
                        >
                            <FontAwesomeIcon icon={faYoutube} />
                        </button>
                        <button
                            className="social-button"
                            aria-label="Instagram"
                            onClick={(e) => handleSocialMediaClick(e, false)}
                            style={{ border: 'none', cursor: 'pointer' }}
                        >
                            <FontAwesomeIcon icon={faInstagram} />
                        </button>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <p style={{ textAlign: 'center' }}>© 2024 Astra Clean Pvt Ltd All rights reserved.</p>
            </div>
            {socialModalOpen && <SocialMediaModal onClose={closeSocialModal} />}
        </div>
    );
}

export default Footer;